import classNames from 'classnames';

import './BookingDetailSection.scss';

type BookingDetailSectionProps = {
  title: string;
  name: string;
  children: React.ReactNode;
  hasProperStyle?: boolean;
  hasPadding?: boolean;
};

export const BookingDetailSection = ({
  title,
  name,
  children,
  hasProperStyle = false,
  hasPadding = true,
}: BookingDetailSectionProps) => (
  <div className="booking-detail-section" id={name}>
    <div className="section-title">{title}</div>
    <div
      className={classNames({
        'section-content': !hasProperStyle,
        'with-padding': !hasProperStyle && hasPadding,
      })}
    >
      {children}
    </div>
  </div>
);
